import React from "react"

const ArrowUpRed = () => {
  return (
    <svg
      width="17"
      height="24"
      viewBox="0 0 17 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.07426 7.06993L7.70963 0.329429C8.1024 -0.0695622 8.71694 -0.106164 9.1504 0.219854L9.2746 0.328538L15.9249 7.06904C16.3577 7.50776 16.3585 8.21985 15.9266 8.65953C15.5339 9.05925 14.9189 9.09622 14.4851 8.77002L14.3608 8.66127L9.60304 3.83748L9.60402 22.8753C9.60402 23.4447 9.18749 23.9153 8.64707 23.9897L8.49683 24C7.93631 24 7.47307 23.5769 7.39976 23.028L7.38965 22.8753L7.38867 3.83448L2.64011 8.66037C2.24704 9.05966 1.63195 9.09598 1.19849 8.76932L1.07431 8.66043C0.681225 8.26116 0.645471 7.63636 0.967063 7.19607L1.07426 7.06993L7.70963 0.329429L1.07426 7.06993Z"
        fill="#C74646"
      />
    </svg>
  )
}

export default ArrowUpRed
